// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"generate-music-button_wrapper__yE8HY"};